const SCRAPED_ITEM_STATUSES = {
  SUCCESS: 'Success',
  PARTIAL_SUCCESS: 'PartialSuccess',
  ERROR: 'Error',
}

export default SCRAPED_ITEM_STATUSES
